module.exports = __webpack_public_path__ + "static/media/profile_bg.a1501829.svg";